import InboxNotificationPreferencesAPI from '../../api/inboxNotificationPreferences';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    // Distingue "ainda não carregou" de "carregou e está vazio": só depois de
    // uma resposta do servidor o filtro por canal pode bloquear notificações.
    isFetched: false,
  },
};

export const getters = {
  getInboxPreferences: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  get: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await InboxNotificationPreferencesAPI.get();
      commit('SET_RECORDS', response.data.inboxes || []);
      commit('SET_UI_FLAG', { isFetched: true });
    } catch (error) {
      // silently fail on fetch
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
  update: async ({ commit }, preferences) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await InboxNotificationPreferencesAPI.update({
        inbox_notification_preferences: preferences,
      });
      commit('SET_RECORDS', response.data.inboxes || []);
      commit('SET_UI_FLAG', { isFetched: true });
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_RECORDS($state, data) {
    $state.records = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
